import { render, staticRenderFns } from "./AS_Notices.vue?vue&type=template&id=1c1cd8f7&scoped=true&"
import script from "./AS_Notices.vue?vue&type=script&lang=js&"
export * from "./AS_Notices.vue?vue&type=script&lang=js&"
import style0 from "./AS_Notices.vue?vue&type=style&index=0&id=1c1cd8f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1cd8f7",
  null
  
)

export default component.exports